<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.501 12.004h15.75M19.501 15.754l3.75-3.75-3.75-3.75M15.75 16.5V21c.036.79-.573 1.46-1.363 1.5H2.114A1.437 1.437 0 0 1 .75 21V3a1.436 1.436 0 0 1 1.363-1.5h12.273c.79.04 1.4.71 1.364 1.5v4.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
